// src/App.js
import React from 'react';
import { useLocation, BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import StartupHeader from './components/StartupHeader';
import StartupFooter from './components/StartupFooter';
import StartupLanding from './components/StartupLanding';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/design-system.css';
import './styles/MoveFlairModal.css';
import ReactGA from 'react-ga';

ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

function AppContent() {
    const location = useLocation();
    const hideFooter = location.pathname === '/review' || location.pathname === '/find-booking';

    const isStartupRoute = location.pathname === '/' || location.pathname === '/home';

    return (
        <>
            {isStartupRoute ? <StartupHeader /> : <Header />}
            <Routes>
                <Route path="/" element={<StartupLanding />} />
                <Route path="/home" element={<StartupLanding />} />
                <Route path="*" element={<StartupLanding />} />
            </Routes>
            {isStartupRoute ? <StartupFooter /> : !hideFooter && <Footer />}
        </>
    );
}

export default App;